const state = () => ({
  flow:null,
  flows:[],
  suppliers:0,
  showclonemodal:false,
  qu_list_to_clone:null,
});
const getters = {
  flow(state){
    return state.flow
  },
  flows(state){
    return state.flows
  },
  suppliers(state){
    return state.suppliers
  },
  showclonemodal(state){
    return state.showclonemodal
  },
  qu_list_to_clone(state){
    return state.qu_list_to_clone
  },
};
const  mutations =  {
  SET_FLOW(state,data){
    state.flow = data
  },
  SET_FLOWS(state,data){
    state.flows = data
  },
  SET_SUPPLIERS(state,data){
    state.suppliers = data
  },
  SET_SHOW_CLONE_MODAL(state,data){
    state.showclonemodal = data
  },
  SET_QU_LIST_TO_CLONE(state,data){
    state.qu_list_to_clone = data
  },
};
const actions =  {
  setFlow({commit},data)  {
    commit("SET_FLOW",data)
  },
  setFlows({commit},data)  {
    commit("SET_FLOWS",data)
  },
  setSuppliers({commit},data)  {
    commit("SET_SUPPLIERS",data)
  },
  setShowCloneModal({commit},data)  {
    commit("SET_SHOW_CLONE_MODAL",data)
  },
  setQuListToClone({commit},data)  {
    commit("SET_QU_LIST_TO_CLONE",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

